import type { PropsWithChildren, ReactNode } from 'react'

type DetailPanelLayoutProps = PropsWithChildren<{
  header?: ReactNode
  footer?: ReactNode
}>

export const DetailPanelLayout = ({
  children,
  header,
  footer,
}: DetailPanelLayoutProps) => (
  <div className="bg-white border-l-2 relative flex flex-col overflow-auto -ml-[2px] border-fv-orange">
    {header && (
      <div className="bg-fv-gray-100 px-6 py-4 border-b border-fv-gray">
        {header}
      </div>
    )}

    <div className="p-6 overflow-auto flex-1 flex-col flex">{children}</div>
    {footer && (
      <div className="border-t border-fv-gray bg-fv-gray-100 py-4 px-6 flex flex-wrap mt-auto">
        {footer}
      </div>
    )}
  </div>
)
